module.exports = __webpack_public_path__ + "prod/1.42.2/img/fenxiao-three.969da5db.png";